
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */


import en from './en';

export default {
  translation: {
    ...en.translation,
    header_title: "Constantina",
    nav_shopping_assistant: "Shopping-Assistent",
    nav_assistant_short: "Assistent",
    nav_style_lab: "Style Lab",
    nav_studio: "Style Studio",
    nav_tryon: "Virtuelle Anprobe",
    nav_actions_title: "Aktionen",
    portfolio_instagram_connect_title: 'Auf Instagram verbinden',
    portfolio_instagram_connect_desc: 'Verfolgen Sie unsere täglichen Style-Stories, Inhalte hinter den Kulissen und Community-Features.',
    common_connect: 'Verbinden',
    voucher_title: "Geschenkgutscheine",
    voucher_cta: "Gutschein kaufen",
    voucher_tagline: "Schenken Sie Stil.",
    portfolio_feature_color_analysis: "Farbberatung",
    portfolio_feature_all_complete_features: "Alle Complete-Paket Leistungen",
    trends_page_subtitle: "Was jetzt angesagt ist",
    trends_page_title: "Modetrends",
    trends_page_description: "Entdecken Sie die neuesten Fashion-Trends, kuratiert für Ihre Generation.",
    trends_filter_all: "Alle Generationen",
    portfolio_video_views: 'Ansichten',
    colorStudio_title: "Farbanalyse-Studio",
    feature_locked_guest: "Funktion gesperrt (Gast)",
    upgrade_membership: "Mitgliedschaft upgraden",
    shoppingAssistant_membership_locked: "Der Shopping-Assistent steht unseren Premium- und Advanced-Mitgliedern zur Verfügung.",
    view_plans: "Pläne anzeigen",
    colorStudio_premium_required: "Schalten Sie die personalisierte saisonale Farbanalyse und Palettenempfehlungen frei. Verfügbar für Premium- und Advanced-Mitglieder.",
    colorStudio_subtitle: "Entfalten Sie die Kraft der Farbe. Entdecken Sie die Nuancen, die mit Ihrem einzigartigen Hautton, Haar und Ihren Augen harmonieren.",
    colorStudio_powerColors_desc: "Die Schlüsselfarben, die Ihre Schönheit zum Strahlen bringen.",
    colorAnalysis_title: "Farbanalyse",
    colorAnalysis_confirm_new: "Sie haben bereits eine Farbanalyse in Ihrem Profil. Möchten Sie eine neue basierend auf Bilderkennung durchführen?",
    colorAnalysis_analyze_new: "Neues Foto analysieren",
    colorAnalysis_analyzing: "Ihre Farben werden analysiert...",
    colorAnalysis_analyzing_subtext: "Bestimmung von Jahreszeit, Hautton und Kontrast.",
    colorAnalysis_upload_title: "Foto hochladen",
    colorAnalysis_upload_btn: "Bild auswählen",
    colorAnalysis_season_label: "Ihre Jahreszeit",
    colorAnalysis_characteristic_skin: "Haut:",
    colorAnalysis_characteristic_contrast: "Kontrast:",
    colorAnalysis_characteristic_eyes: "Augen:",
    colorAnalysis_characteristic_hair: "Haar:",
    colorAnalysis_powerColors: "Powerfarben",
    colorAnalysis_neutrals: "Neutraltöne",
    colorAnalysis_avoid: "Zu vermeidende Farben",
    colorAnalysis_advice_hair_makeup: "Haar & Make-up",
    colorAnalysis_advice_clothing: "Kleidungsberatung",
    colorAnalysis_error: "Analyse fehlgeschlagen.",
    colorAnalysis_no_result_title: "Noch keine Farbanalyse",
    colorAnalysis_no_result_desc: "Laden Sie ein Foto hoch oder wählen Sie ein gespeichertes Outfit, um Ihre persönliche Farbsaison und Palette zu entdecken.",
    colorAnalysis_start_button: "Meine Farbanalyse starten",
    colorAnalysis_label_hair: "Haar",
    colorAnalysis_label_makeup: "Make-up",
    colorAnalysis_label_jewelry: "Schmuck",
    colorAnalysis_saved_to_profile: "Im Profil gespeichert",
    colorAnalysis_save_to_profile: "Analyse im Profil speichern",
    colorAnalysis_apply_palette_title: "Palette auf Outfit anwenden",
    colorAnalysis_apply_palette_hint: "Klicken Sie auf eine Farbe, um sie anzuwenden",
    colorAnalysis_apply_color_aria: "Farbe {{color}} anwenden",
    colorAnalysis_target_item: "Zielartikel",
    colorAnalysis_powerColors_desc: "Diese Kernfarben projizieren Ihr maximales Selbstbewusstsein und Ihre Ausstrahlung.",
    myStylesPage_savedColorAnalysis_title: "Meine Farbpaletten-Analyse",
    myStylesPage_savedColorAnalysis_desc: "Ihre Geschichte persönlicher Farb- und Saisonentdeckungen.",
    myStylesPage_noSavedAnalysis: "Noch keine Farbanalyseergebnisse gespeichert.",
    colorAnalysis_admin_mode: "ADMIN",
    colorAnalysis_admin_analyzing: "Kuratiertes Set wird analysiert...",
    colorAnalysis_admin_label: "Admin-Modus:",
    colorAnalysis_admin_desc: "Laden Sie ein detailliertes Outfit-Foto hoch, um Artikel zu extrahieren und ein Shop the Look-Set zu erstellen.",
    colorAnalysis_admin_save_set: "In kuratierten Sets speichern",
    colorAnalysis_admin_shop_now: "Shop Now Link",
    colorAnalysis_admin_failed_analyze: "Analyse des Sets fehlgeschlagen",
    colorAnalysis_admin_failed_save: "Speichern fehlgeschlagen.",
    colorAnalysis_admin_curated_saved: "Kuratiertes Set & Artikel lokal gespeichert! (Seite neu laden, um sie in der Garderobe zu sehen)",
    colorAnalysis_characteristic_skinTone: "Hautton:",
    colorAnalysis_characteristic_hairColor: "Haarfarbe:",
    colorAnalysis_characteristic_eyeColor: "Augenfarbe:",
    colorAnalysis_characteristic_faceShape: "Gesichtsform:",
    colorAnalysis_characteristic_bodySize: "Körperbau:",
    colorAnalysis_save_to_advice_title: "Farbanalyse - {{season}}",
    colorAnalysis_unknown: "Unbekannt",
    colorAnalysis_saved_to_profile_success: "Im Profil gespeichert",

    // Travel Page
    travelPage_seo_title: "Luxus-Mode Reise-Packliste & Resort Wear",
    travelPage_seo_desc: "Kuratieren Sie die ultimative Luxus-Reise-Packliste. Von Resort-Wear bis hin zu Essentials für Städtetrips, planen Sie Ihren stilvollen Kurzurlaub mit KI-gestützten Outfit-Empfehlungen.",
    travelPage_seo_keywords: "Luxus-Reise-Packliste, Mode-Reise-Packliste, Resort-Wear, schicke Reise-Garderobe, Urlaubs-Outfits, hochwertige Reise-Essentials, Designer-Packliste",
    travelPage_diaries_title: "Reisetagebücher",
    travelPage_no_lookbooks: "Keine Reise-Lookbooks gefunden.",
    travelPage_destination_label: "Wohin geht die Reise?",
    travelPage_destination_placeholder: "z.B. Paris, Tulum, Aspen",
    travelPage_style_summer: "Sommer / Strand",
    travelPage_style_winter: "Winter / Ski",
    travelPage_generating: "Garderobe wird kuratiert...",
    travelPage_generate_btn: "Packliste generieren",
    travelPage_result_title: "Ihre Capsule für {{destination}}",
    travelPage_save_diary: "Im Tagebuch speichern",
    travelPage_export_pdf: "PDF exportieren",

    // Mock Travel Items
    travelPage_item_blazer: "Leinenblazer - Beige",
    travelPage_item_camisole: "Seiden-Unterhemd - Weiß",
    travelPage_item_trousers: "Weite Hose - Marineblau",
    travelPage_item_sandals: "Ledersandalen - Hellbraun",
    travelPage_item_earrings: "Statement-Ohrringe - Gold",
    travelPage_item_hat: "Sonnenhut - Geflochten",
    travelPage_item_clutch: "Abend-Clutch - Schwarz",
    travelPage_item_swimsuit: "Badeanzug - Einteiler",

    // Carousel
    carousel_winter_elegance: "Winter-Eleganz: Die Kunst des Layering",
    carousel_spring_elegance: "Frühlings-Eleganz: Textur & Bewegung",
    carousel_minimalist_wardrobe: "Der Leitfaden für eine minimalistische Garderobe",
    carousel_power_dressing: "Power Dressing: Die sanfte Revolution",
    carousel_spring_trends: "Trendbericht Frühjahr 2026",
    carousel_sustainable_fashion: "Nachhaltige Mode: Bewusste Entscheidungen",
    carousel_accessory_edit: "Das Accessoire-Edit: Von Nebensache zu Architektur",
    carousel_sport_edit: "Sport Chic: Die neue athletische Ästhetik",
    carousel_evening_glamour: "Abend-Glamour: Nächtliche Ästhetik",
    carousel_travel_essentials: "Reise-Essentials: Die Jet-Set-Capsule",
    carousel_instagram_reel: "Instagram Reel",

    rss_source_constantina: "Constantina",

    "portfolio.title": "Portfolio",
    "portfolio.description": "Eine Auswahl unserer besten Arbeiten.",
    "portfolio.searchPlaceholder": "Portfolio durchsuchen...",
    "portfolio.noResults.title": "Keine Projekte gefunden",
    "portfolio.noResults.message": "Versuchen Sie es mit anderen Suchbegriffen.",
    "portfolio_category_editorial": "Editorial",
    "portfolio_category_street": "Street Style",
    "portfolio_category_commercial": "Kommerziell",
    "portfolio_category_portraits": "Portraits",
    "portfolio_category_personal": "Personal Styling",
    "portfolio_category_wardrobe": "Garderobe",
    "portfolio_category_events": "Events",
    "portfolio_category_specialty": "Spezial",
    "portfolio.item1.title": "Urban Vogue",
    "portfolio.item1.desc": "City Chic Editorial",
    "portfolio.item2.title": "Street Beat",
    "portfolio.item2.desc": "Zeitgenössische Street-Fashion",
    "portfolio.item3.title": "Summer Haze",
    "portfolio.item3.desc": "Kommerzielle Kampagne",
    "portfolio.item4.title": "Modern Muse",
    "portfolio.item4.desc": "High Fashion Editorial",
    "portfolio.item5.title": "Raw Essence",
    "portfolio.item5.desc": "Natürliches Licht Portraits",

    "socialCarousel_simulation_note": "* Simulierter Social-Media-Feed",
    stylingAdvisorPage_agent_fashionExpert_name: 'Mode-Experte',
    stylingAdvisorPage_agent_fashionExpert_description: 'Allgemeine Stilberatung und Trend-Scouting.',
    stylingAdvisorPage_agent_minimalistStylist_name: 'Minimalistischer Stylist',
    stylingAdvisorPage_startChat: 'Chat starten',
    stylingAdvisorPage_title: 'Persönlicher Styling-Berater',
    stylingAdvisorPage_agent_minimalistStylist_description: 'Klare Linien, neutrale Paletten und Capsule Wardrobes.',
    stylingAdvisorPage_greeting: "Hallo! Ich bin Ihr persönlicher KI-Stylist. Wie kann ich Ihnen heute helfen, Ihren Look zu verbessern?",
    stylingAdvisorPage_tagline: "Ihr persönlicher KI-Modeberater.",
    stylingAdvisorPage_chatSection: "Chat",
    stylingAdvisorPage_agentSelectorLabel: "Wähle einen Agenten",
    stylingAdvisorPage_planSectionTitle: "Stil-Plan",
    stylingAdvisorPage_planSectionDescription: "Erstellen Sie eine persönliche Stil-Roadmap basierend auf Ihren Vorlieben.",
    stylingAdvisorPage_photoAnalysisSectionTitle: "Farbanalyse",
    stylingAdvisorPage_photoAnalysisSectionDescription: "Laden Sie ein Foto hoch, um Ihre saisonale Farbpalette zu entdecken.",
    stylingAdvisorPage_photoAnalysisButton: "Mein Foto analysieren",
    stylingAdvisorPage_photoAnalysisSelectLabel: "Aus gespeicherten Outfits auswählen",
    stylingAdvisorPage_agentsSectionTitle: "Automatisierte Agenten",
    stylingAdvisorPage_agentsDashboardTitle: "Meine aktiven Stil-Agenten",
    stylingAdvisorPage_createAgent: "Neuen Agenten erstellen",
    stylingAdvisorPage_noAgents: "Sie haben noch keine automatisierten Agenten erstellt.",
    stylingAdvisorPage_thinking: "Nachdenken...",
    stylingAdvisorPage_generatePlan: "Plan erstellen",
    stylingAdvisorPage_regeneratePlan: "Neu generieren",
    stylingAdvisorPage_saveSuccess: "Gespeichert!",
    stylingAdvisorPage_planSavedTitle: "{{duration}} Stil-Plan",
    stylingAdvisorPage_placeholder: "Fragen Sie nach Rat...",
    stylingAdvisorPage_planDuration_weekly: "Wöchentlich",
    stylingAdvisorPage_planDuration_monthly: "Monatlich",
    stylingAdvisorPage_planDuration_quarterly: "Vierteljährlich",
    stylingAdvisorPage_mandatory_fields_tooltip: "Vervollständigen Sie Ihre Stil-Persona im Profil, um dies freizuschalten.",
    stylingAdvisorPage_agent_styleQuestionnaire_name: "Stil-Fragebogen",
    stylingAdvisorPage_agent_styleQuestionnaire_description: "Entdecken Sie Ihre einzigartige Stil-Persona durch Fragen und Antworten.",
    stylingAdvisorPage_agent_business_name: "Business Professional",
    stylingAdvisorPage_agent_business_description: "Beratung für Corporate- und Smart-Casual-Kleidung.",
    stylingAdvisorPage_agent_vogueEditor_name: "Editorial Chic",
    stylingAdvisorPage_agent_vogueEditor_description: "High-Fashion, mutige und trendsetzende Looks.",
    stylingAdvisorPage_agent_glamour_name: "Red Carpet Glamour",
    stylingAdvisorPage_agent_glamour_description: "Abendgarderobe und Styling für besondere Anlässe.",
    stylingAdvisorPage_agent_locked_basic: "Basis-Plan erforderlich",
    stylingAdvisorPage_agent_locked_premium: "Premium-Plan erforderlich",
    stylingAdvisorPage_agent_locked_advanced: "Advanced-Plan erforderlich",
    stylingAdvisorPage_planError: "Stil-Plan konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    stylingAdvisorPage_questionnaire_wizard_lifestyle_outdoor: "Wie viel Zeit verbringen Sie im Freien / draußen?",
    "bookingForm_success_message_email": "Ihre Buchungsanfrage wurde gesendet. Bitte überprüfen Sie Ihre E-Mails für die Kalendereinladung.",

    styleBot_questionnaire_intro: "Hallo! Um Ihnen den besten Rat zu geben, würde ich gerne wissen: 1. Geschlecht 2. Körperform 3. Gesichtsform 4. Farbjahreszeit 5. Stilvorliebe. Sie können alles auf einmal oder nacheinander beantworten!",
    styleBot_chip_female: "Weiblich",
    styleBot_chip_male: "Männlich",
    styleBot_chip_non_binary: "Nicht-binär",
    styleBot_chip_hourglass: "Sanduhr-Figur",
    styleBot_chip_pear: "Birnen-Figur",
    styleBot_chip_rectangle: "Rechteck-Figur",
    styleBot_chip_athletic: "Sportliche Statur",
    styleBot_chip_oval_face: "Ovales Gesicht",
    styleBot_chip_square_face: "Eckiges Gesicht",
    styleBot_chip_round_face: "Rundes Gesicht",
    styleBot_chip_heart_face: "Herzförmiges Gesicht",
    styleBot_chip_winter: "Winter-Typ",
    styleBot_chip_summer: "Sommer-Typ",
    styleBot_chip_autumn: "Herbst-Typ",
    styleBot_chip_spring: "Frühling-Typ",
    styleBot_chip_minimalist: "Minimalistischer Stil",
    styleBot_chip_boho: "Boho Chic",
    styleBot_chip_classic: "Klassischer Stil",
    styleBot_chip_streetwear: "Streetwear",

    "styleAgent_modal_title": "Stil-Agent konfigurieren",
    "voucher_modal_title": "Geschenkgutschein kaufen",
    "voucher_modal_success_title": "Gutschein erstellt!",
    "voucher_modal_success_message": "Ihr Gutschein wurde erfolgreich erstellt. Sie können den Code unten kopieren.",
    "voucher_modal_service_label": "Dienstleistungen auswählen",
    "voucher_modal_recipient_name_label": "Name des Empfängers",
    "voucher_modal_recipient_name_placeholder": "z.B. Maria Muster",
    "voucher_modal_recipient_email_label": "E-Mail des Empfängers",
    "voucher_modal_recipient_email_placeholder": "maria@beispiel.de",
    "voucher_modal_message_label": "Persönliche Nachricht",
    "voucher_modal_message_placeholder": "Schreiben Sie eine Notiz...",
    "voucher_modal_purchase_button": "Gutschein kaufen",
    "voucher_modal_purchasing": "Verarbeite...",
    "voucher_modal_copy_code": "Code kopieren",
    styleAgent_modal_desc: "Richten Sie einen automatisierten Agenten ein, der im Hintergrund Trends scoutet und Outfits plant.",
    styleAgent_name_label: "Agenten-Name",
    styleAgent_name_placeholder: "z.B. Sommerurlaub-Scout",
    styleAgent_frequency_label: "Häufigkeit",
    styleAgent_season_label: "Ziel-Saison",
    styleAgent_focus_label: "Stil-Fokus",
    styleAgent_create_btn: "Agent aktivieren",
    styleAgent_freq_weekly: "Wöchentlich",
    styleAgent_freq_monthly: "Monatlich",

    guestAccess_message: "Bitte melden Sie sich an, um auf diese Funktion zuzugreifen.",
    myStylesPage_sourceOutfit: 'Outfit-Quelle',
    myStylesPage_social_linkedin: 'LinkedIn',
    myStylesPage_social_twitter: 'Twitter',
    myStylesPage_social_instagram: 'Instagram',
    myStylesPage_title: 'Meine Styles',
    myStylesPage_tagline: 'Ihre kuratierten Styles und Inspirationen.',
    myStylesPage_outfitsTab: 'Outfits',
    myStylesPage_favoritesTab: 'Favoriten',
    myStylesPage_lookbooksTab: 'Lookbooks',
    myStylesPage_adviceTab: 'Gespeicherte Tipps',
    myStylesPage_analyticsTab: 'Stil-Analyse',
    myStylesPage_filterPlaceholder: 'Artikel filtern...',
    myStylesPage_sortNewest: 'Neueste',
    myStylesPage_sortOldest: 'Älteste',
    myStylesPage_sortNameAsc: 'Name (A-Z)',
    myStylesPage_sortNameDesc: 'Name (Z-A)',
    myStylesPage_compareMode_title: 'Vergleichsmodus',
    myStylesPage_compareMode_select: 'Zum Vergleichen auswählen',
    myStylesPage_compareMode_compareButton: 'Vergleichen ({{count}}/2)',
    myStylesPage_exportBooklet: 'Stilbericht exportieren',
    myStylesPage_noPreview: 'Keine Vorschau verfügbar',
    myStylesPage_favorite_remove_aria: 'Aus Favoriten entfernen',
    myStylesPage_favorite_add_aria: 'Zu Favoriten hinzufügen',
    myStylesPage_loadOutfit: 'Outfit laden',
    myStylesPage_deleteOutfit: 'Outfit löschen',
    myStylesPage_createLookbook: 'Lookbook erstellen',
    myStylesPage_lookbookDescription: '{{count}} Outfits',
    myStylesPage_noLookbooks: 'Noch keine Lookbooks erstellt.',
    myStylesPage_noAdvice: 'Noch keine Tipps gespeichert.',
    myStylesPage_analyzeOutfit: 'Outfit analysieren',
    myStylesPage_savePlan: 'Plan speichern',
    myStylesPage_adviceSaved: 'Gespeichert!',
    myStylesPage_saveAdvice: 'Tipp speichern',
    myStylesPage_outfitDescriptionBase: 'Eine stilvolle Kombination.',
    myStylesPage_no_results: 'Keine gespeicherten Outfits gefunden.',
    myStylesPage_empty_title: "Noch keine Styles",
    myStylesPage_empty_desc: "Erstellen Sie Outfits im Dressing Room, um sie hier zu sehen.",
    myStylesPage_tab_outfits: "Gespeicherte Outfits",
    myStylesPage_tab_items: "Garderoben-Artikel",
    myStylesPage_delete_confirm: "Sind Sie sicher, dass Sie diesen Style löschen möchten?",
    myStylesPage_created_at: "Erstellt am",
    blog_post_not_found: 'Beitrag nicht gefunden.',
    common_pdf: 'PDF',
    resource_category_style: 'Stil',
    resource_category_color: 'Farbe',
    resource_category_business: 'Business',
    // Existing translations start here

    "rss_1_title": "Vogues Guide zu den Trends 2024",
    "rss_1_snippet": "Entdecken Sie die wichtigsten Stücke, die die Ästhetik dieser Saison definieren.",
    "rss_2_title": "Street Style Highlights",
    "rss_2_snippet": "Die besten Looks von den Straßen von Mailand und Paris.",
    "rss_3_title": "Die Zukunft der Schuhe",
    "rss_3_snippet": "Die neuesten Drops und Kollaborationen in der Schuhszene.",
    "rss_4_title": "Nachhaltiger Luxus",
    "rss_4_snippet": "Wie High-End-Marken umweltfreundliche Materialien verwenden.",
    "rss_5_title": "Beauty entschlüsselt",
    "rss_5_snippet": "Die Top-Beauty-Trends direkt vom Laufsteg.",
    "rss_6_title": "InStyle Fashion Guide",
    "rss_6_snippet": "Curated shopping picks",
    "rss_7_title": "Glamour Runway Report",
    "rss_7_snippet": "Behind the scenes at fashion week",
    "rss_8_title": "Beige Editorial",
    "rss_8_snippet": "Minimalist style and aesthetics",
    "rss_9_title": "Refinery29 Style Tips",
    "rss_9_snippet": "Fresh takes on current fashion",
    "rss_10_title": "BoF Industry Insights",
    "rss_10_snippet": "The business side of fashion",
    "rss_11_title": "Grazia Trends",
    "rss_11_snippet": "Expert style advice",
    "rss_12_title": "Original Copy Mag",
    "rss_12_snippet": "Digital fashion culture",
    "rss_13_title": "Modepilot Updates",
    "rss_13_snippet": "Daily fashion news",
    "rss_14_title": "FashionUnited Global",
    "rss_14_snippet": "International fashion network",
    "rss_15_title": "Jolie Style",
    "rss_15_snippet": "Lifestyle and trends",
    "rss_16_title": "Cosmopolitan Fashion",
    "rss_16_snippet": "Empowering style choices",
    "rss_17_title": "Masha Sedgwick Blog",
    "rss_17_snippet": "Personal style and storytelling",
    "rss_18_title": "Ohh Couture Lifestyle",
    "rss_18_snippet": "Luxury travel and fashion",
    "rss_19_title": "Caro Daur Diaries",
    "rss_19_snippet": "Behind the scenes with Caro",
    "rss_20_title": "Novalanalove Style",
    "rss_20_snippet": "Daily outfit inspiration",
    // ... existing translations ...

    "campaign_new_year_title": "Neues Jahr, Neuer Stil",
    "campaign_new_year_desc": "Frischen Sie Ihren Look für das neue Jahr auf.",
    "campaign_event_glamour_title": "Event-Glamour",
    "campaign_event_glamour_desc": "Glänzen Sie bei Ihrem nächsten großen Event.",
    "campaign_executive_title": "Führungspräsenz",
    "campaign_executive_desc": "Beherrschen Sie den Raum mit einem starken professionellen Image.",
    "campaign_color_title": "Perfekte Palette",
    "campaign_color_desc": "Entdecken Sie die Farben, die Sie zum Strahlen bringen.",
    "campaign_shopping_title": "Klug Einkaufen",
    "campaign_shopping_desc": "Kuratierte Stücke, die perfekt zu Ihrem Lebensstil passen.",
    "campaign_style_transformation_title": "Totale Transformation",
    "campaign_style_transformation_desc": "Erfinden Sie sich neu mit unserem umfassenden Styling-Workshop.",
    "campaign_summer_title": "Strahlender Sommer-Stil",
    "campaign_summer_desc": "Genießen Sie die Sonne mit lebendigen Paletten und luftigen Silhouetten.",
    "campaign_easter_title": "Frühlingserneuerung zu Ostern",
    "campaign_easter_desc": "Frischen Sie Ihren Look mit Pastell-Eleganz und saisonalen Texturen auf.",
    "campaign_badge_new": "Neu",
    "campaign_badge_trending": "Angesagt",
    "campaign_soft_power_title": "Soft Power Revolution",
    "campaign_soft_power_desc": "Entdecken Sie die Executive-Ästhetik für 2026: abgerundete Schultern, pastellfarbene Power-Suits und fließende Schnitte.",
    "campaign_sportif_chic_title": "Sportif Chic & Wellness",
    "campaign_sportif_chic_desc": "Gehobene Sportbekleidung trifft auf Alltagsluxus. Technische Stoffe mit femininem Touch.",

    "campaign_badge_limited_time": "Begrenzte Zeit",
    "campaign_badge_events": "Saison-Spezial",
    "campaign_badge_professional": "Professionell",
    "campaign_badge_bestseller": "Bestseller",
    "campaign_badge_seasonal": "Saisonal",
    "campaign_badge_exclusive": "Exklusiv",
    "campaign_included_services": "Inbegriffene Leistungen",

    // ========== BOOKLET TRANSLATIONS ==========
    "booklet_minimalist_title": "Leitfaden für die minimalistische Garderobe",
    "booklet_minimalist_desc": "Meistern Sie die Kunst, eine vielseitige, hochwertige Garderobe mit weniger Stücken aufzubauen.",
    "booklet_color_theory_title": "Grundlagen der Farblehre",
    "booklet_color_theory_desc": "Entdecken Sie Ihre perfekte Farbpalette und lernen Sie, harmonische Outfits zu kreieren.",
    "booklet_executive_title": "Styling für Führungspräsenz",
    "booklet_executive_desc": "Professioneller Styling-Leitfaden für den Aufbau von Autorität durch Ihre Garderobe.",
    "booklet_capsule_title": "Der Blueprint für die Capsule Wardrobe",
    "booklet_capsule_desc": "Vollständiger Leitfaden zur Erstellung saisonaler Capsule-Kollektionen, die zusammenpassen.",
    "booklet_downloading": "Wird heruntergeladen",

    // ... existing translations ...

    "wardrobe_searchPlaceholder": "Artikel suchen...",
    "price_basic_weekly": "9,99 €/Woche",
    "price_basic_monthly": "29,99 €/Monat",
    "price_basic_quarterly": "79,99 €/Vierteljahr",
    "price_premium_weekly": "19,99 €/Woche",
    "price_premium_monthly": "59,99 €/Monat",
    "price_premium_quarterly": "159,99 €/Vierteljahr",
    "price_advanced_weekly": "39,99 €/Woche",
    "price_advanced_monthly": "119,99 €/Monat",
    "price_advanced_quarterly": "319,99 €/Vierteljahr",
    "price_nextgen_weekly": "4,99 €/Woche",
    "price_nextgen_monthly": "14,99 €/Monat",
    "portfolioPage_package_online": "Online",
    "portfolioPage_package_aiEnhanced": "KI-optimiert",
    "portfolioPage_package_inPerson": "Persönlich",
    "price_personal_styling_online": "150 €",
    "price_personal_styling_ai": "250 €",
    "price_business_workshop_corporate": "5.000 €+",
    "price_style_transformation_essential": "450 €",
    "price_style_transformation_complete": "850 €",
    "price_style_transformation_vip": "1.500 €",
    "price_wardrobe_curation_online": "200 €",
    "price_wardrobe_curation_ai": "300 €",
    "price_wardrobe_curation_in_person": "600 €",
    "price_event_styling_online": "100 €",
    "price_event_styling_ai": "180 €",
    "price_event_styling_in_person": "400 €",
    "price_individual_shopping_online": "120 €",
    "price_individual_shopping_ai": "220 €",
    "price_individual_shopping_in_person": "450 €",
    "price_makeup_advisory_online": "80 €",
    "price_makeup_advisory_ai": "150 €",
    "price_makeup_advisory_in_person": "300 €",
    "price_color_analysis_online": "90 €",
    "price_color_analysis_ai": "160 €",
    "price_color_analysis_in_person": "350 €",
    "loading_updating_item": "Artikel wird aktualisiert...",

    // Portfolio Page (Merged below)
    portfolio_feature_1hr_video_call: "1 Std. Videoanruf",
    portfolio_feature_style_questionnaire: "Stil-Fragebogen",
    portfolio_feature_personalized_mood_board: "Personalisiertes Moodboard",
    portfolio_feature_all_online_features: "Alle Online-Funktionen",
    portfolio_feature_virtual_try_on_session: "Virtuelle Anprobe-Sitzung",
    portfolio_feature_ai_lookbook: "KI-Lookbook",
    portfolio_feature_retail_search: "Einzelhandelssuche",
    portfolio_feature_all_ai_features: "Alle KI-Funktionen",
    portfolio_feature_in_person_consultation: "Persönliche Beratung",
    portfolio_feature_hands_on_styling: "Praktisches Styling",
    portfolio_feature_wardrobe_analysis: "Garderobenanalyse",
    portfolio_feature_declutter_guide: "Ausmist-Leitfaden",
    portfolio_feature_shopping_list: "Einkaufsliste",
    portfolio_feature_ai_outfit_pairing: "KI-Outfit-Paarung",
    portfolio_feature_seasonal_capsule: "Saisonale Kapsel",
    portfolio_feature_event_consultation: "Event-Beratung",
    portfolio_feature_3_outfit_proposals: "3 Outfit-Vorschläge",
    portfolio_feature_accessorizing_guide: "Accessoire-Leitfaden",
    portfolio_feature_event_virtual_try_on: "Event-Virtuelle Anprobe",
    portfolio_feature_pose_variation_check: "Posen-Variations-Check",
    portfolio_feature_shopping_consultation: "Einkaufsberatung",
    portfolio_feature_curated_shopping_list: "Kuratierte Einkaufsliste",
    portfolio_feature_style_integration_session: "Stil-Integrationssitzung",
    portfolio_feature_ai_product_search: "KI-Produktsuche",
    portfolio_feature_vto_shortlist: "VTO-Engere Auswahl",
    portfolio_feature_makeup_video_call: "Make-up Videoanruf",
    portfolio_feature_product_recommendations: "Produktempfehlungen",
    portfolio_feature_technique_guide: "Technik-Leitfaden",
    portfolio_feature_ai_face_analysis: "KI-Gesichtsanalyse",
    portfolio_feature_virtual_makeup_try_on: "Virtuelle Make-up Anprobe",
    portfolio_feature_color_consultation: "Farbberatung",
    portfolio_feature_digital_palette: "Digitale Palette",
    portfolio_feature_outfit_color_guide: "Outfit-Farbleitfaden",
    portfolio_feature_ai_color_detection: "KI-Farberkennung",
    portfolio_feature_interactive_palette: "Interaktive Palette",
    portfolio_feature_team_style_guide: "Team-Stil-Leitfaden",
    portfolio_feature_brand_identity_alignment: "Markenidentitäts-Abgleich",
    portfolio_feature_group_qa: "Gruppen-F&A",
    portfolio_feature_executive_presence: "Führungspräsenz",
    portfolio_feature_personal_shopping_day: "Persönlicher Einkaufstag",
    portfolio_feature_keynote_speech: "Keynote-Rede",
    "portfolio_feature_pop_up_styling": "Pop-up Styling Bar",
    "portfolio_feature_wardrobe_edit": "Garderoben-Check",
    "portfolio_feature_style_guide": "Style-Guide",
    "portfolio_feature_personal_shopping": "Personal Shopping",
    "portfolio_feature_makeup_lesson": "Make-up Lektion",
    "portfolio_feature_follow_up": "Nachbesprechung",
    "portfolio_feature_photoshoot": "Professionelles Fotoshooting",
    "portfolio_feature_hair_consultation": "Haarberatung",
    "portfolio_feature_vip_concierge": "VIP Concierge",

    // Booking Page
    "bookingPage_title": "Beratung Buchen",
    "bookingPage_tagline": "Planen Sie ein persönliches Gespräch mit unseren Experten.",
    "bookingPage_service_personal": "Persönliches Styling",
    "bookingPage_service_wardrobe": "Garderoben-Check",
    "bookingPage_service_shopping": "Personal Shopping",

    // Blog Page
    "blogPage_title": "Style Journal",
    "blogPage_tagline": "Einblicke, Trends und Expertenrat.",
    "blogPage_resources_title": "Exklusive Ressourcen",
    "blogPage_resources_locked_msg": "Upgrade auf Premium, um auf unsere Style-Guides zuzugreifen.",
    "blogPage_resources_upgrade": "Jetzt Upgraden",
    "blog_post_read_more": "Weiterlesen",
    "editorial_rss_title": "Branchen-News",
    "editorial_rss_subtitle": "Kuratierte Feeds von Top-Modepublikationen.",

    // Canvas / Dressing Room
    "canvas_seo_title": "Virtuelle Umkleidekabine - Constantina",
    "canvas_seo_desc": "Probieren Sie Outfits virtuell an mit unserer AI-Technologie. Ihr persönlicher KI-Stylist.",
    "canvas_seo_keywords": "KI Virtuelle Anprobe, Virtuelle Umkleidekabine, Digitaler Kleiderschrank, Personal Stylist, Mode Technologie",
    "canvas_uploadToStart": "Laden Sie ein Foto hoch, um zu beginnen",
    "canvas_view3D": "In 3D Ansehen",
    "canvas_shopTheLook": "Look Kaufen",
    "canvas_favorite_add": "Zu Favoriten hinzufügen",
    "canvas_favorite_remove": "Aus Favoriten entfernen",
    "sceneControl_title": "Szenen-Einstellungen",
    "sceneControl_custom_bg_placeholder": "Beschreiben Sie einen Hintergrund...",

    "portfolioPage_service_personalStyling_title": "Personal Styling",
    "portfolioPage_service_personalStyling_description": "Komplette Stilüberarbeitung.",
    "portfolioPage_service_wardrobeCuration_title": "Garderoben-Kuration",
    "portfolioPage_service_wardrobeCuration_description": "Optimieren Sie Ihren Kleiderschrank.",
    "portfolioPage_service_eventStyling_title": "Event Styling",
    "portfolioPage_service_eventStyling_description": "Perfekter Look für jeden Anlass.",
    "portfolioPage_service_individualShopping_title": "Personal Shopping",
    "portfolioPage_service_individualShopping_description": "Kuratierte Einkaufserfahrung.",
    "portfolioPage_service_makeupAdvisory_title": "Make-up Beratung",
    "portfolioPage_service_makeupAdvisory_description": "Schönheit passend zu Ihrem Stil.",
    "portfolioPage_service_colorAnalysis_title": "Farbanalyse",
    "portfolioPage_service_colorAnalysis_description": "Finden Sie Ihre perfekte Palette.",
    "portfolioPage_service_premiumInPerson_title": "Premium Persönlich",
    "portfolioPage_service_businessWorkshops_title": "Business Styling & Workshops",
    "portfolioPage_service_businessWorkshops_description": "Verbessern Sie das professionelle Image Ihres Unternehmens.",
    "portfolioPage_service_styleTransformation_title": "Stil-Transformation",
    "portfolioPage_service_styleTransformation_description": "Eine komplette Neuerfindung Ihres persönlichen Stils.",
    "portfolioPage_package_essential": "Essential",
    "portfolioPage_package_complete": "Komplett",
    "portfolioPage_package_vip": "VIP",

    "styleReport_title": "Stilbericht",
    "styleReport_generatedFor": "Generiert für {{username}}",
    "styleReport_date": "Datum",
    "styleReport_profile_title": "Stilprofil",
    "styleReport_no_persona": "Noch keine Stil-Persona generiert.",
    "styleReport_outfits_title": "Gespeicherte Outfits",
    "styleReport_lookbooks_title": "Lookbooks",
    "styleReport_plans_title": "Stilpläne",
    "styleReport_no_plans": "Keine Stilpläne gespeichert.",
    "styleReport_back": "Zurück zu Meine Styles",
    "styleReport_print": "Bericht drucken",

    "agentWorkflow_title": "Styling-Agent",
    "agentWorkflow_greeting": "Hallo! Ich bin Ihr persönlicher Styling-Agent. Ich kann Ihnen helfen, Artikel zu finden, Termine zu buchen oder Social-Media-Inhalte für Ihre Looks zu erstellen. Was haben Sie auf dem Herzen?",
    "agentWorkflow_error_noItemsFound": "Ich konnte leider keine ähnlichen Artikel finden.",
    "agentWorkflow_fallback": "Das habe ich nicht ganz verstanden. Versuchen Sie zu fragen: 'Ähnliche Artikel finden' oder 'Sitzung buchen'.",
    "agentWorkflow_error": "Entschuldigung, ein Fehler ist aufgetreten.",
    "agentWorkflow_thinking": "Verarbeite...",
    "auth_error_invalid_credentials": "Ungültige E-Mail-Adresse oder Passwort.",
    "agentWorkflow_placeholder": "Geben Sie eine Anfrage ein...",
    "agentWorkflow_socialMediaSavedTitle": "Social-Media-Inhalt",

    "trendSpotter.greeting": "Bereit, der Zeit voraus zu sein? Ich bin Ihr Trend-Spotter. Fragen Sie mich nach den neuesten Laufsteg-Hits, viralen Street-Styles oder den Farben der Saison!",
    "trendSpotter.cleared": "Chat-Verlauf gelöscht.",
    "trendSpotter.thinking": "Analysiere globale Trends...",
    "trendSpotter.placeholder": "Nach aufkommenden Trends fragen...",
    "sceneControl_bg_studio": "Studio",
    "sceneControl_bg_street": "Straße",
    "sceneControl_bg_nature": "Natur",
    "sceneControl_bg_cafe": "Café",
    "sceneControl_bg_beach": "Strand",
    "sceneControl_background_label": "Hintergrund",
    "sceneControl_modelScale_label": "Modellskalierung",
    "loading_updating_pose": "Pose wird zu {{poseName}} geändert...",
    "loading_updating_background": "Hintergrund wird aktualisiert...",
    "loading_updating_3d": "3D-Ansicht wird generiert ({{current}}/4)...",
    "error_update_outfit": "Aktualisierung fehlgeschlagen. {{details}}",
    "error_save_outfit": "Speichern fehlgeschlagen. {{details}}",
    "common_user": "Benutzer",
    "common_back": "Zurück",
    "common_next": "Weiter",
    "canvas_colorPicker_title": "Farbauswahl",
    "wardrobe_item_tooltip_locked": "Gesperrt: Erfordert {{level}}-Mitgliedschaft.",
    "wardrobe_item_tooltip_category": "Kategorie: {{category}}",
    "wardrobe_item_tooltip_color": "Standardfarbe: {{color}}",
    "wardrobe_brand_ai_generated": "KI-generiert",
    "wardrobe_item_ai_name_prefix": "KI: {{prompt}}",

    // ... (rest of the file content, simplified for brevity as the new keys are the focus)
    "appName": "Constantina",
    "carousel_fruling_elegance": "Frühlings-Eleganz",
    "carousel_fruling_casual": "Frühlings-Casual",
    "carousel_fruling_elegant": "Frühlings-Elegant",
    "nav_home": "Startseite",
    "nav_about": "Über uns",
    "nav_portfolio": "Portfolio",
    "nav_blog": "Blog",
    "nav_services": "Dienstleistungen",
    "nav_bookSession": "Sitzung buchen",
    "nav_dressingRoom": "Umkleidekabine",
    "nav_myStyles": "Meine Styles",
    "nav_advisor": "Stil-Berater",
    "nav_trends": "Trends",
    "nav_privacy": "Datenschutz",
    "nav_terms": "AGB",
    "nav_impressum": "Impressum",
    "nav_startOver": "Neu beginnen",
    "nav_save": "Speichern",
    "nav_share": "Teilen",
    "nav_findSimilar": "Ähnliches finden",
    "nav_getStyleTip": "Tipps erhalten",
    "nav_lookbook": "Lookbook",
    "nav_lightMode": "Heller Modus",
    "nav_darkMode": "Dunkler Modus",
    "nav_switchUser": "Benutzer wechseln",
    "nav_profile": "Profil",
    "nav_wardrobe": "Garderobe",
    "nav_outfit": "Outfit",
    "nav_guestCta": "Anmelden für Zugriff",
    "nav_show_wardrobe": "Garderobe anzeigen",
    "nav_hide_wardrobe": "Garderobe verbergen",
    "nav_show_outfit": "Outfit anzeigen",
    "nav_hide_outfit": "Outfit verbergen",
    "nav_signInGoogle": "Mit Google anmelden",
    "nav_signInDrive": "Mit Google Drive anmelden",
    "nav_signInPhotos": "Mit Google Photos anmelden",
    "nav_signInFacebook": "Mit Facebook anmelden",
    "nav_rememberMe": "Angemeldet bleiben",
    "nav_signUp": "Registrieren",
    "nav_emailPlaceholder": "E-Mail",
    "nav_passwordPlaceholder": "Passwort",
    "nav_signUpButton": "Konto erstellen",
    "nav_continueWith": "Oder weiter mit",
    "nav_guestUser": "(Gast)",
    "nav_proceedToStyling": "Zum Styling",
    "nav_help": "Hilfe-Center",

    "footer_company": "Unternehmen",
    "footer_legal": "Rechtliches",
    "footer_subscribe_title": "Bleiben Sie im Trend",
    "footer_subscribe_desc": "Abonnieren Sie unseren Newsletter für exklusive Stiltipps und Trends.",
    "footer_subscribe_placeholder": "Geben Sie Ihre E-Mail ein",
    "footer_subscribe_button_aria": "Abonnieren",
    "footer_subscribe_success": "Danke fürs Abonnieren!",
    "footer_subscribe_error": "Bitte geben Sie eine gültige E-Mail ein.",
    "footer_copyright": "Alle Rechte vorbehalten.",
    "footer_createdBy": "Erstellt von",
    "homePage_businessStyling": "Für Unternehmen",
    "homePage_cta": "Virtuell Anprobieren",
    "loading_rendering": "Details werden gerendert...",
    "loading_generating_model": "Kreiere das neue Du...",
    "homePage_bookConsultation": "Beratung Buchen",
    "homePage_uploadInput_label": "Laden Sie Ihr Foto hoch",
    "homePage_visionTitle": "Unsere Vision",
    "homePage_vision_time_title": "Mühelose Morgenroutine",
    "homePage_vision_time_desc": "Eliminieren Sie Entscheidungsnotstand. Unsere KI plant Ihre Outfits der Woche in Sekunden, damit Sie sich auf das Wesentliche konzentrieren können.",
    "homePage_vision_quality_title": "Schweizer Qualität & Präzision",
    "homePage_vision_quality_desc": "In der Schweiz gegründet, bringen wir kompromisslose Standards bei Qualität und Datensicherheit in Ihren digitalen Kleiderschrank.",
    "homePage_vision_digitalTwin_title": "Italienisches Design-Erbe",
    "homePage_vision_digitalTwin_desc": "Durchdrungen von der Seele der Mailänder Mode, ist unsere KI auf den Prinzipien italienischer Eleganz und Schneiderei geschult.",
    "homePage_transformation_title": "Transformation",
    "homePage_transformation_desc": "Sehen Sie den Unterschied.",
    "legalPage_title": "Rechtliche Informationen",
    "legalPage_tagline": "Nutzungsbedingungen, Datenschutz und wichtige rechtliche Informationen.",
    "seo_legal_title": "Rechtliche Informationen - AGB & Datenschutz",
    "seo_legal_description": "Lesen Sie unsere Nutzungsbedingungen, Datenschutzerklärung, Cookie-Richtlinie und Impressum.",
    "seo_legal_kw1": "nutzungsbedingungen",
    "seo_legal_kw2": "datenschutzerklärung",
    "seo_legal_kw3": "rechtliche informationen",
    "seo_legal_kw4": "impressum",
    "legalPage_impressum_title": "Impressum",
    "legalPage_impressum_content": "<p><b>Constantina Lifestyle AG</b><br/>Bern, Schweiz<br/>E-Mail: info@constantinalifestyle.one</p>",
    "legalPage_terms_title": "Allgemeine Geschäftsbedingungen",
    "legalPage_terms_content": "<p>Durch die Nutzung unseres Dienstes erklären Sie sich mit unseren Bedingungen zur Verarbeitung digitaler Assets und KI-generierter Inhalte einverstanden.</p>",
    "legalPage_privacy_title": "Datenschutzerklärung",
    "legalPage_privacy_content": "<p>Wir schätzen Ihre Privatsphäre. Ihre biometrischen und persönlichen Daten werden nach Möglichkeit lokal verarbeitet und mit Industriestandards gesichert.</p>",
    "legalPage_cookies_title": "Cookie-Richtlinie",
    "legalPage_cookies_content": "<p>Wir verwenden notwendige Cookies, um Ihre Sitzung und Einstellungen beizubehalten.</p>",
    "pressPage_title": "Presse & Kooperationen",
    "pressPage_tagline": "Führend im Gespräch über digitale Modeinnovation.",
    "pressPage_featured_title": "Bekannt aus",
    "pressPage_partners_title": "Markenpartner",
    "press_vogue_quote": "Definiert persönliches Styling mit KI-Präzision neu.",
    "press_harpers_quote": "Die Zukunft der digitalen Garderobe ist da.",
    "press_elle_quote": "Eine nahtlose Mischung aus Technologie und High Fashion.",
    "press_brand1_desc": "Exklusive digitale Showroom-Integration.",
    "press_brand2_desc": "Virtuelle Anprobe-Partnerschaft.",
    "press_brand3_desc": "Kuratierte Capsule Collection.",
    "rss_source_vogue": "Vogue",
    "rss_source_elle": "Elle",
    "rss_source_harpers": "Harper's Bazaar",
    "rss_source_fashionista": "Fashionista",
    "rss_source_bof": "Business of Fashion",
    "rss_source_journelles": "Journelles",
    "rss_source_highsnobiety": "Highsnobiety",
    "rss_source_instyle": "InStyle",
    "rss_source_glamour": "Glamour",
    "rss_source_beige": "Beige",
    "rss_source_refinery29": "Refinery29",
    "rss_source_grazia": "Grazia",
    "rss_source_originalcopy": "The Original Copy",
    "rss_source_modepilot": "Modepilot",
    "rss_source_fashionunited": "FashionUnited",
    "rss_source_jolie": "Jolie",
    "rss_source_cosmopolitan": "Cosmopolitan",
    "rss_source_mashasedgwick": "Masha Sedgwick",
    "rss_source_ohhcouture": "Ohh Couture",
    "rss_source_carodaur": "Caro Daur",
    "rss_source_novalanalove": "Novalanalove",
    "payment_modal_select_method": "Zahlungsart wählen",
    "payment_method_card": "Kreditkarte",
    "payment_method_paypal": "PayPal",
    "payment_method_klarna": "Klarna",
    "payment_method_twint": "Twint",
    "payment_method_sofort": "Sofort",
    "payment_email_label": "E-Mail-Adresse bestätigen",
    "payment_mobile_label": "Mobilnummer",
    "payment_cardholder_name": "Name des Karteninhabers",
    "payment_card_number": "Kartennummer",
    "payment_expiry": "Gültig bis",
    "payment_cvc": "CVC",
    "payment_error_email_required": "E-Mail-Adresse ist erforderlich.",
    "payment_error_phone_required": "Mobilnummer ist erforderlich.",
    "payment_error_invalid_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "payment_error_invalid_phone": "Bitte geben Sie eine gültige Mobilnummer ein.",
    "payment_error_invalid_card": "Ungültige Kartennummer.",
    "payment_error_invalid_expiry": "Ungültiges oder abgelaufenes Datum.",
    "payment_error_invalid_cvc": "Ungültiger CVC.",
    "payment_success_title": "Zahlung erfolgreich!",
    "payment_success_message": "Ihre Mitgliedschaft wurde erfolgreich aktualisiert.",
    "payment_failed_title": "Zahlung fehlgeschlagen",
    "payment_failed_message": "Wir konnten Ihre Zahlung nicht verarbeiten. Bitte versuchen Sie es erneut.",
    "payment_continue_to": "Weiter zur Zahlung mit {{method}}",
    "blogPage_resources_locked_title": "Premium-Inhalte freischalten",
    "portfolioPage_title": "Premium KI-Stylist & Personal Branding",
    "portfolioPage_tagline": "Steigern Sie Ihr professionelles Image mit unseren maßgeschneiderten Styling-Paketen und Executive-Branding-Lösungen.",
    "seo_services_title": "Premium Styling-Services",
    "seo_services_description": "Buchen Sie professionelle Styling-Beratung, Garderoben-Kuration und Executive-Branding-Sessions.",
    "seo_services_kw1": "Personal Styling",
    "seo_services_kw2": "Garderoben-Kuration",
    "seo_services_kw3": "Image-Beratung",
    "seo_services_kw4": "Virtuelles Anprobieren",
    "portfolioPage_campaigns_title": "Aktuelle Kampagnen",
    "portfolioPage_campaigns_tagline": "Exklusive Angebote für begrenzte Zeit.",
    "portfolioPage_membership_title": "Mitgliedschaftspläne",
    "portfolioPage_membership_tagline": "Schalten Sie exklusive Funktionen und Inhalte frei.",
    "portfolioPage_services_title": "Unsere Dienstleistungen",
    "portfolioPage_all_categories": "Alle Kategorien",
    "portfolioPage_bookService": "Dienstleistung buchen",
    "membership_cycle_weekly": "Wöchentlich",
    "membership_cycle_monthly": "Monatlich",
    "membership_cycle_quarterly": "Vierteljährlich",
    "membership_subscribe_button": "Jetzt abonnieren",
    "membership_cycle_free": "Kostenlos",
    "profilePage_membership_free": "Kostenlos",
    "membership_feature_free_1": "Standard-Stil-Entdeckung",
    "membership_feature_free_2": "Kuratierter Stil-Feed",
    "membership_feature_basic_1": "Standard-Zugriff",
    "membership_feature_basic_2": "Basis-Garderobe",
    "membership_feature_basic_3": "Begrenzte Anproben",
    "membership_feature_basic_4": "Community-Support",
    "membership_feature_premium_1": "Priorisierter Zugriff",
    "membership_feature_premium_2": "Unbegrenzte Garderobe",
    "membership_feature_premium_3": "Unbegrenzte Anproben",
    "membership_feature_premium_4": "E-Mail-Support",
    "membership_feature_premium_5": "Exklusive Inhalte",
    "membership_feature_premium_style_tips": "KI-Stiltipps",
    "membership_feature_advanced_1": "Alle Premium-Funktionen",
    "membership_feature_advanced_2": "1-zu-1-Beratung",
    "membership_feature_advanced_3": "Frühzeitiger Zugriff",
    "membership_feature_advanced_4": "VIP-Support",
    "membership_feature_advanced_5": "Personal Shopper",
    "membership_feature_advanced_social_media": "Social Content Gen",
    "membership_feature_advanced_plan_integration": "Stilplan-Integration",
    "membership_feature_advanced_automated_shopping": "Automatisierter Einkauf",
    "membership_feature_nextgen_1": "Eco-Stil Einblicke",
    "membership_feature_nextgen_2": "Social Trends Alarme",
    "membership_feature_nextgen_3": "Kuratierte Second-Hand Guides",
    "membership_feature_nextgen_4": "TikTok Trend Integration",


    "nav_user_status_current": "Aktuell",
    "nav_user_status_active": "Aktive Sitzung",
    "nav_user_action_login": "Anmelden",
    "nav_user_action_delete": "Benutzer löschen",
    "nav_admin_model_config": "Admin: Modellkonfiguration",
    "nav_admin_model_image_label": "Bildgenerierungsmodell",
    "nav_admin_model_image_desc": "Primäres Modell für hochwertige Outfit- und Modellgenerierung.",
    "nav_admin_model_flash_label": "Flash-Analysemodell",
    "nav_admin_model_flash_desc": "Schnelles Modell für Kurzanalyse, Chat-Zusammenfassungen und Trend-Spotting.",
    "nav_admin_model_pro_label": "Fortgeschrittene Analyse (Pro)",
    "nav_admin_model_pro_desc": "Leistungsstarkes Modell für tiefere Einblicke und komplexe Modeanalysen.",
    "nav_admin_model_thinking_label": "Deep Think Modell",
    "nav_admin_model_thinking_desc": "Spezialisiertes Denkmodell für Stilpläne und nuancierte Vergleiche.",
    "nav_admin_model_video_label": "Videogenerierung (Veo)",
    "nav_admin_model_video_desc": "Das Modell für filmische 3D- und Modevideos.",
    "nav_membership_recommended": "EMPFEHLUNG",
    "membership_most_popular": "Am beliebtesten",
    "nav_app_download_prefix_ios": "Laden im",
    "nav_app_store_ios": "App Store",
    "nav_app_download_prefix_android": "JETZT BEI",
    "nav_app_store_android": "Google Play",


    "home_hero_title": "Meistern Sie Ihren persönlichen Stil mit KI-Präzision",
    "home_hero_title_new": "Steigern Sie Ihre Präsenz. Nie wieder fragen, was man anziehen soll.",
    "home_hero_subtitle": "Ihr professioneller KI-Mode-Concierge kombiniert mit Schweizer Persönlichkeit und Qualität. Erleben Sie kuratierte Looks, die auf Ihre einzigartige Palette, Körperform und persönliche Marke zugeschnitten sind.",
    "home_hero_cta": "Styling-Sitzung beginnen",
    "home_seo_title": "Constantina | Ihr persönlicher KI-Mode- & Stilberater",
    "home_seo_desc": "Verwandeln Sie Ihr Shopping-Erlebnis mit unserer virtuellen KI-Umkleidekabine. Entdecken Sie Ihren Stil mit 2026-Trends wie Transformative Teal und Quiet Luxury.",
    "home_seo_keywords": "Virtuelle Anprobe, KI Fashion Stylist, Personal Styling, Virtueller Umkleideraum, Mode Innovation, NYFW Looks, Couture Styling, Garderobenberater, KI Fashion Tech, Transformative Teal, Y2K Renaissance, Nachhaltige Mode, Stealth Wealth",
    "home_empathy_title": "Stil ist persönlich. Das verstehen wir.",
    "home_empathy_desc": "Wir glauben, dass Mode stärken und nicht einschüchtern sollte. Unsere KI lernt Ihre individuellen Vorlieben, Ihren Körper und Ihren Lebensstil kennen, um Empfehlungen zu geben, die sich authentisch anfühlen — kein trendjagendes Programm.",
    "home_press_title": "Bekannt aus",
    "profilePage_measurements_colorSeason_label": "Farbprofil (Jahreszeit)",
    "profilePage_measurements_ai_auto_detect": "KI-Auto-Erkennung",
    "profilePage_stylePersona_analyzing_dna": "Analysiere deine Stil-DNA...",

    "profile_seo_title": "Mein Profil - Constantina",
    "profile_seo_desc": "Verwalten Sie Ihre Stil-Persona, Mitgliedschaft und Kontoeinstellungen auf Constantina.",
    "profile_seo_keywords": "Benutzerprofil, Stil-Persona, Kontoeinstellungen, Constantina",

    "canvas_result_alt": "Virtual Try-On Ergebnis",
    "aboutPage_title": "Die Kunst des Stylings trifft auf künstliche Intelligenz",
    "aboutPage_tagline": "Die Brücke zwischen zeitloser Eleganz und modernster Modetechnologie schlagen.",
    "aboutPage_paragraph1": "Im Herzen der Schweiz gegründet, entstand Constantina aus einer einzigen Vision: die anspruchsvollste Imageberatung der Welt zu demokratisieren. Wir glauben, dass wahrer Stil mehr ist als nur Kleidung – er ist ein strategisches Gut und eine kraftvolle Form des Selbstausdrucks, die durch die Verbindung von menschlicher Expertise und fortschrittlicher Technologie für jeden zugänglich ist.",
    "aboutPage_paragraph2": "Heute dient unsere Plattform als globaler persönlicher Stil-Concierge und befähigt Einzelpersonen, ihre berufliche und persönliche Präsenz mit der Zuversicht eines Meisterschneiders zu steuern, untermauert durch die Präzision generativer KI.",
    "aboutPage_missionText": "Stil ist die stille Sprache der Identität. Unsere Mission ist es, Ihnen die Werkzeuge an die Hand zu geben, um diese fließend, mit absolutem Vertrauen und strategischer Wirkung zu sprechen, überall auf der Welt.",
    "aboutPage_techTitle": "Die Intelligenz hinter der Kunst",
    "aboutPage_techText_p1": "Wir verwenden die fortschrittlichsten multimodalen Modelle – Gemini 2.0 und darüber hinaus –, um visuelle Analysen von Kleidungsstücken, Texturen und Silhouetten in Echtzeit durchzuführen.",
    "aboutPage_techText_p2": "Jede Empfehlung basiert auf professionellen Styling-Prinzipien, Farblehre und historischen Modekontexten, um sicherzustellen, dass unsere KI ein Werkzeug zur Aufwertung bleibt, nicht nur zur Automatisierung.",
    "aboutPage_teamTitle": "Unsere Visionäre",
    "aboutPage_socialTitle": "Verbinden Sie sich mit unserer Zukunft",
    "aboutPage_socialText": "Treten Sie unserer Gemeinschaft zukunftsorientierter Stylisten und Technikbegeisteris bei, während wir definieren, was es bedeutet, gut gekleidet zu sein.",
    "about_usp_title": "Warum Constantina?",
    "about_usp_1_title": "Menschzentrierte KI",
    "about_usp_1_desc": "Die Effizienz von KI kombiniert mit der Intuition erfahrener Stylisten.",
    "about_usp_2_title": "Datengetriebene Trends",
    "about_usp_2_desc": "Echtzeitanalyse globaler Trends aus den wichtigsten Modemetropolen.",
    "about_usp_3_title": "Persönliches Branding",
    "about_usp_3_desc": "Wir kleiden Sie nicht nur ein; wir helfen Ihnen, Ihr authentischstes Selbst zu projizieren.",
    "about_usp_4_title": "Globale Reichweite",
    "about_usp_4_desc": "High-End-Styling zugänglich, egal wo auf der Welt Sie sich befinden.",
    "about_certification_title": "Unsere Zertifizierungen",
    "about_certification_desc": "Fachwissen, das von führenden Modeinstitutionen anerkannt wird.",
    "aboutPage_certified_milano": "Master in Fashion Styling - Mailand",
    "aboutPage_certified_london": "Fashion Communication - London",
    "wardrobe_item_elegant_blue": "Elegantes blaues Kleid",
    "wardrobe_item_elegant_black_stairs": "Elegantes schwarzes Abendkleid",
    "wardrobe_item_elegant_wool_coat": "Eleganter Wollmantel",
    "wardrobe_item_elegant_gray_studio": "Graues Art-Studio-Ensemble",
    "wardrobe_item_elegant_autumn": "Herbstliche Stadt-Eleganz",
    "accessory_set_elegant_collection": "Elegante Kollektion",
    "aboutPage_contactUs": "Beratung buchen",
    "author_elara_vance_name": "Constantina",
    "author_elara_vance_bio": "Eine Veteranin der Mailänder Modehäuser mit einer tiefen Leidenschaft für die Schnittstelle von Technologie und traditionellem Styling.",
    "elara-vance_role": "Creative Director",
    "author_julian_sinclair_name": "Hannes",
    "author_julian_sinclair_bio": "Spezialisiert auf KI-Ethik und visuelle Verarbeitungsmuster, um sicherzustellen, dass unser Styling menschlich und intuitiv bleibt.",
    "julian-sinclair_role": "Head of AI Architecture",
    "author_heidi_steiner_name": "Heidi Steiner",
    "author_heidi_steiner_bio": "Bringt jahrelange Erfahrung im High-End-Boutique-Concierge-Bereich in die digitale Sphäre.",
    "heidi-steiner_role": "Chief Concierge",
    "author_lukas_weber_name": "Lukas Weber",
    "author_lukas_weber_bio": "Konzentriert sich auf nachhaltige Modedaten und Transparenz bei der Beschaffung im digitalen Zeitalter.",
    "lukas-weber_role": "Sustainability Lead",
    "contact_title": "Lass uns vernetzen",
    "contact_subtitle": "Haben Sie Fragen zu unserem KI-Styling oder möchten Sie einen maßgeschneiderten Workshop buchen? Melden Sie sich bei uns und wir werden uns innerhalb von 24 Stunden bei Ihnen melden.",
    "contact_info_title": "Kontaktdetails",
    "contact_email_label": "E-Mail",
    "contact_phone_label": "Telefon",
    "contact_office_label": "Büro",
    "contact_follow_us": "Folge uns",
    "contact_success_title": "Nachricht gesendet!",
    "contact_success_desc": "Vielen Dank für Ihre Kontaktaufnahme. Konstantina wird Ihre Nachricht prüfen und in Kürze antworten.",
    "contact_form_name": "Name",
    "contact_form_email": "E-Mail",
    "contact_form_subject": "Betreff",
    "contact_form_message": "Nachricht",
    "contact_form_submit": "Nachricht verarbeiten",
    "contact_form_placeholder_name": "Dein Name",
    "contact_form_placeholder_email": "deine@email.com",
    "contact_form_placeholder_subject": "Worum geht es?",
    "contact_form_placeholder_message": "Sagen Sie uns, wie wir helfen können...",
    "contact_form_send_another": "Weitere Nachricht senden",
    "wardrobe_item_uploaded_name": "Mein hochgeladenes Foto",
    "brand_custom": "Eigener",
    "material_custom": "Standard",
    "nav_logout": "Abmelden",
    "generation_alpha": "Gen Alpha",
    "generation_z": "Gen Z",
    "generation_millennial": "Millennials",
    "generation_classic": "Klassisch / Boomers",
    "trend_alpha_digital_twin_title": "Digital Twin Sync",
    "trend_alpha_gaming_couture_title": "Meta-Gaming Couture",
    "trend_z_y2k_redux_title": "Y2K Redux Ästhetik",
    "trend_z_thrifting_elite_title": "Deep Thrifting Kurationen",
    "trend_millennial_80s_glam_title": "80er Power Glam",
    "trend_millennial_quiet_luxury_title": "Quiet Luxury",
    "trend_classic_heritage_title": "Heritage Outdoors",
    "trend_tag_ai_native": "AI Native",
    "trend_tag_metaverse": "Metaverse",
    "trend_tag_nostalgia": "Nostalgie",
    "trend_tag_eco_conscious": "Öko-Elite",
    "trend_tag_sophisticated": "Anspruchsvoll",
    "trend_tag_timeless": "Zeitlos",
    "trend_tag_heritage": "Heritage",
    "trend_tag_sculpted": "Skulptural",
    "trend_tag_heritage_fusion": "Heritage Fusion",
    "trend_tag_ai_vision": "KI-Vision",
    "trend_tag_emerging": "Nachwuchs",
    "trend_tag_alpine_chic": "Alpiner Chic",
    "trend_tag_cyber_soft": "Cyber Soft",
    "trend_tag_poet_core": "Poet Core",
    "trend_tag_glamoratti": "Glamoratti",
    "trend_tag_guardian": "Guardian",
    "trend_alpha_cyber_soft_title": "Digitale Pastell-Fusion",
    "trend_z_poet_core_title": "Romantische Akademikerin",
    "trend_millennial_glamoratti_title": "80er Opulenz Redux",
    "trend_classic_guardian_title": "Schützende Eleganz",
    "portfolio.alpha.title": "Gen Alpha Digitale Identitäten",
    "portfolio.alpha.desc": "Verbindung von virtuellen Skins mit physischen Luxusgarderoben für die erste Digital-Native-Generation.",
    "portfolio.z.title": "Gen Z Individualität",
    "portfolio.z.desc": "KI-gestütztes Thrifting und Social Trends Spotting für Trendsetter.",
    "portfolio.millennial.title": "Millennial Karriere-Höhepunkt",
    "portfolio.millennial.desc": "Gehobener 80er-Jahre-Glamour und zeitloser Quiet Luxury für den modernen Profi.",
    "campaign.zara.title": "ZARA: Runway Reimagined 2026",
    "campaign.zara.desc": "Ein kommerzieller Deep-Dive in die SS26-Kollektion von ZARA, der skulpturale Silhouetten mit urbanem Utilitarismus verbindet.",
    "campaign.hm.title": "H&M: Year of the Horse x Jacques Wei",
    "campaign.hm.desc": "Editoriale Fusion aus östlichem Erbe und modernem Streetstyle, die den Geist von 2026 einfängt.",
    "campaign.mango.title": "Mango: Sunset Dream AI Vision",
    "campaign.mango.desc": "Eine innovative, KI-generierte Kampagne für Mango Teen, die die Grenzen digitaler Ästhetik erkundet.",
    "campaign.zalando.title": "Zalando: Visionary Award 2026",
    "campaign.zalando.desc": "Die Zukunft der Mode präsentiert durch die Linse der besten Nachwuchsdesigner von Zalando.",
    "campaign.pkz.title": "PKZ: Zurich Fashion Week Elegance",
    "campaign.pkz.desc": "Premium-Styling und High-End-Eleganz von der führenden Schweizer Modeadresse.",
    "home_how_it_works_title": "Ihr Weg zu Schweizer Exzellenz und italienischem Stil",
    "home_how_it_works_step1_title": "1. Präzise visuelle Analyse",
    "home_how_it_works_step1_desc": "Beginnen Sie mit einer visuellen Analyse, die Ihre einzigartige Aura einfängt. Unsere in der Schweiz entwickelte KI erfasst Ihre Proportionen mit chirurgischer Präzision.",
    "home_how_it_works_step2_title": "2. Kuratierte italienische Einblicke",
    "home_how_it_works_step2_desc": "Entdecken Sie kuratierte Empfehlungen mit einem italienischen Auge für Details, die sicherstellen, dass jede Kombination 'Sprezzatura' und Selbstvertrauen ausstrahlt.",
    "home_how_it_works_step3_title": "3. Experten-Kuration & Meisterschaft",
    "home_how_it_works_step3_desc": "Der letzte Schliff menschlicher Meisterschaft. Buchen Sie bei unseren erfahrenen Stylisten, um Ihre Transformation mit persönlicher Sorgfalt abzurunden.",

    "blogPage_seo_title": "Style Journal | Constantina",
    "blogPage_seo_desc": "Entdecken Sie Expertenwissen, Trendberichte und exklusive Style-Guides von Constantina.",
    "blogPage_seo_keywords": "mode blog, stiltipps, trendberichte, lookbooks, modenews",

    "contactPage_seo_title": "Kontakt | Constantina",
    "contactPage_seo_desc": "Kontaktieren Sie das Constantina-Team für Workshops, Support oder allgemeine Anfragen.",
    "contactPage_seo_keywords": "kontakt, kundensupport, mode-workshop buchen, anfragen",

    "pressPage_seo_title": "Presse & Medien | Constantina",
    "pressPage_seo_desc": "Lesen Sie die neuesten Presseberichte und Features über Constantinas KI-gesteuertes Styling.",
    "pressPage_seo_keywords": "mode presse, medienberichte, constantina news, digitale modeinnovation",

    "bookingPage_seo_title": "Beratung Buchen | Constantina",
    "bookingPage_seo_desc": "Buchen Sie eine persönliche Styling-Sitzung, einen Garderoben-Check oder ein Einkaufserlebnis.",
    "bookingPage_seo_keywords": "styling buchen, personal stylist termin, garderobenberatung, modeberater",

    "portfolioPage_seo_title": "Unsere Services & Portfolio | Constantina",
    "portfolioPage_seo_desc": "Entdecken Sie unsere Premium-Styling-Services und sehen Sie unser Portfolio an Transformationen.",
    "portfolioPage_seo_keywords": "styling portfolio, personal styling services, mode transformationen, kundenstories",

    "myStylesPage_seo_title": "Meine Garderobe & Outfits | Constantina",
    "myStylesPage_seo_desc": "Verwalten Sie Ihre digitale Garderobe, gespeicherte Outfits und Stilberichte.",
    "myStylesPage_seo_keywords": "digitale garderobe, gespeicherte outfits, stilverwaltung, virtueller kleiderschrank",

    "helpPage_seo_title": "Hilfe-Center | Constantina",
    "helpPage_seo_desc": "Finden Sie Antworten auf häufige Fragen zu Constantinas Funktionen und Mitgliedschaft.",
    "helpPage_seo_keywords": "hilfe center, faq, support, styling guide, wie benutzt man constantina",
    "trends_seo_title": "Modetrends 2026 | Constantina",
    "trends_seo_desc": "Entdecken Sie die neuesten Gen Z und globalen Modetrends. Bleiben Sie mit KI-gestützten Einblicken immer einen Schritt voraus.",
    "trends_seo_keywords": "modetrends, gen z stil, 2026 mode, trend spotting, nachhaltige mode",

    "profilePage_register_to_unlock": "Registrieren zum Freischalten",
    "profilePage_guest_cta_title": "Entfalten Sie Ihr volles Stilpotenzial",
    "profilePage_guest_cta_desc": "Treten Sie Constantina noch heute bei, um Ihre Outfits zu speichern, Ihre Stil-Persona zu generieren und personalisierte Empfehlungen von unseren KI-Stylisten zu erhalten.",
    "profilePage_socialConnections_title": "Soziale Verbindungen",
    "profilePage_socialConnections_description": "Verbinden Sie Ihre sozialen Konten, um Ihren Stil zu synchronisieren und Ihre Looks zu teilen.",
    "profilePage_admin_model_image_label": "Bildgenerierungsmodell",
    "profilePage_admin_model_image_desc": "Wählen Sie das Gemini-Modell für die Bildgenerierung.",
    "profilePage_admin_model_image_flash_25": "Gemini 2.0 Flash (Next-Gen)",
    "profilePage_admin_model_image_3_flash": "Gemini 3 Flash (Schnell)",
    "profilePage_admin_model_image_imagen_3": "Imagen 3.0 (Pro Image)",
    "profilePage_admin_model_flash_label": "Flash-Analysemodell",
    "profilePage_admin_model_flash_desc": "Wählen Sie das schnelle Modell für die visuelle Analyse.",
    "profilePage_admin_model_flash_stable": "Gemini 1.5 Flash (Stabil)",
    "profilePage_admin_model_pro_label": "Pro-Reasoning-Modell",
    "profilePage_admin_model_pro_desc": "Wählen Sie das hochwertige Reasoning-Modell.",
    "profilePage_admin_model_pro_stable": "Gemini 1.5 Pro (Stabil)",
    "profilePage_admin_model_thinking_label": "Thinking-Modell",
    "profilePage_admin_model_thinking_desc": "Wählen Sie das fortgeschrittene Reasoning-Modell.",
    "profilePage_admin_model_deep_think": "Gemini 2.0 Thinking (Reasoning)",
    "profilePage_admin_model_video_label": "Videogenerierungsmodell",
    "profilePage_admin_model_video_desc": "Wählen Sie das Modell für die Videogenerierung.",
    "profilePage_admin_model_video_veo": "Veo (Cinematisch)",
    "profilePage_admin_model_video_veo_2": "Veo 2.0 (Stabil)",
    "shoppingAssistant_title": "Shopping-Assistent",
    "shoppingAssistant_subtitle": "KI-Unterstützt",
    "shoppingAssistant_greeting": "Hallo! Ich bin dein KI-Shopping-Assistent. Wie kann ich dir heute helfen? Du kannst mich fragen, Produkte zu finden, deinen Bestellstatus zu prüfen oder bei Rücksendungen zu helfen.",
    "shoppingAssistant_error_connection": "Es tut mir leid, ich habe gerade Probleme mit der Verbindung.",
    "shoppingAssistant_history_cleared": "Verlauf gelöscht. Wie kann ich dir heute helfen?",
    "shoppingAssistant_clear_history": "Verlauf löschen",
    "shoppingAssistant_close": "Assistent schließen",
    "shoppingAssistant_role_assistant": "Assistent",
    "shoppingAssistant_copy_caption": "Beschriftung kopieren",
    "shoppingAssistant_social_media_title": "KI-generierte Social-Media-Texte",
    "shoppingAssistant_save_to_advice": "In Beratung speichern",
    "shoppingAssistant_select_slot": "Auswählen",
    "shoppingAssistant_thinking": "Assistent überlegt...",
    "shoppingAssistant_input_placeholder": "Produkte suchen, Bestellungen verfolgen...",
    "shoppingAssistant_send_aria": "Nachricht senden",
    "shoppingAssistant_suggest_summer_dresses": "Sommerkleider",
    "shoppingAssistant_suggest_track_order": "Bestellung verfolgen",
    "shoppingAssistant_suggest_return_policy": "Rückgaberecht",
    "shoppingAssistant_response_products": "Ich habe einige {{category}} gefunden, die dir gefallen könnten:",
    "shoppingAssistant_response_order_status": "Hier ist der Status deiner Bestellung {{orderId}}:",
    "shoppingAssistant_response_order_not_found": "Ich konnte diese Bestellung nicht finden. Bitte überprüfe die Bestellnummer und versuche es erneut.",
    "shoppingAssistant_response_return_policy": "Unsere Rückgaberegelung erlaubt es dir, Artikel innerhalb von 30 Tagen nach der Lieferung zurückzugeben. Die Artikel müssen ungetragen und in der Originalverpackung sein. Möchtest du eine Rücksendung für eine bestimmte Bestellung starten?",
    "shoppingAssistant_response_social_media": "Ich habe einige individuelle Social-Media-Texte basierend auf deinem aktuellen Look entworfen! Welcher gefällt dir am besten?",
    "shoppingAssistant_response_social_no_garment": "Ich würde dir gerne bei einem Post helfen! Könntest du bitte zuerst ein Kleidungsstück in der Garderobe auswählen, damit ich worüber schreiben kann?",
    "shoppingAssistant_response_booking": "Ich kann dir auf jeden Fall helfen, eine professionelle Styling-Beratung zu buchen. Wann hattest du an gedacht?",
    "shoppingAssistant_service_styling_consultation": "Persönliche Styling-Beratung",
    "shoppingAssistant_response_wardrobe_matches": "Ich habe einige Treffer in deiner Garderobe gefunden, plus ein paar Teile aus unserem Katalog, um den Look zu vervollständigen:",
    "shoppingAssistant_response_retail_matches": "Basierend auf deinen Stilpräferenzen habe ich diese Artikel für dich gefunden:",
    "shoppingAssistant_response_greeting": "Hallo! Ich bin dein persönlicher Stil- und Shopping-Assistent. Ich kann dir helfen, Produkte zu finden (in unserem Shop oder deiner Garderobe), Social-Media-Posts für deine Looks zu erstellen oder eine Beratung zu buchen. Wie kann ich dir heute helfen?",
    "shoppingAssistant_response_fallback": "Ich bin hier, um dir bei deinem Stil zu helfen! Du kannst mich bitten, Produkte zu finden, Social-Posts zu erstellen oder dir Modeberatung zu geben.",
    "shoppingAssistant_order_status_label": "Bestellstatus",
    "shoppingAssistant_order_id_label": "Bestellnummer",
    "shoppingAssistant_order_date_label": "Datum",
    "shoppingAssistant_order_items_label": "Artikel",
    "shoppingAssistant_order_total_label": "Gesamtbetrag",
    "shoppingAssistant_order_est_delivery_label": "Voraussichtliche Lieferung",
    "shoppingAssistant_order_track_cta": "Paket verfolgen",
    "shoppingAssistant_order_status_shipped": "Versandt",
    "shoppingAssistant_order_status_delivered": "Geliefert",
    "shoppingAssistant_order_status_processing": "In Bearbeitung",
    "shoppingAssistant_product_in_wardrobe": "In deiner Garderobe",
    "shoppingAssistant_product_low_stock": "Geringer Bestand",
    "shoppingAssistant_product_price_wardrobe": "GARDEROBE",
    "shoppingAssistant_product_add_to_basket": "In den Warenkorb",
    "shoppingAssistant_product_owned": "Bereits im Besitz",
    "shoppingAssistant_product_already_in_wardrobe": "Bereits in deiner Garderobe",


    // Wardrobe & Outfit Stack (New)
    "wardrobe_category_Tops": "Oberteile",
    "wardrobe_category_Jackets": "Jacken & Mäntel",
    "wardrobe_category_Outerwear": "Oberbekleidung",
    "wardrobe_category_Dresses": "Kleider",
    "wardrobe_category_Bottoms": "Unterteile",
    "wardrobe_category_Shoes": "Schuhe",
    "wardrobe_category_Bags": "Taschen",
    "wardrobe_category_Eyewear": "Brillen",
    "wardrobe_category_Jewelry": "Schmuck",
    "wardrobe_category_Other": "Accessoires & Sonstiges",
    "wardrobe_category_All": "Alle Kategorien",

    "lifeSphere_selection_title": "Dein aktueller Fokus",
    "lifeSphere_selection_desc": "Wähle deine aktive Life Sphere, um die Empfehlungen anzupassen.",
    "lifeSphere_executive_title": "Exekutive Aufstieg",
    "lifeSphere_executive_desc": "Gehobene berufliche Präsenz und Power-Dressing.",
    "lifeSphere_romantic_title": "Romantische Renaissance",
    "lifeSphere_romantic_desc": "Verführerisches, selbstbewusstes Styling für dein Liebesleben.",
    "lifeSphere_matriarch_title": "Mühelose Matriarchin",
    "lifeSphere_matriarch_desc": "Schicke, funktionale Eleganz für das Familienleben.",
    "lifeSphere_creative_title": "Kreatives Aufblühen",
    "lifeSphere_creative_desc": "Mutige Silhouetten, die künstlerisches Wachstum widerspiegeln.",
    "wardrobe_tab_garments": "Kleidung",
    "wardrobe_tab_accessories": "Accessoires",
    "wardrobe_tab_sets": "Kuratierte Sets",
    "wardrobe_upload_garment_title": "Neues Kleidungsstück hinzufügen",
    "wardrobe_upload_accessory_title": "Neues Accessoire hinzufügen",
    "wardrobe_upload_garment": "Hochladen",
    "wardrobe_upload_accessory": "Hochladen",

    "outfitStack_title": "Outfit-Zusammenstellung",
    "outfitStack_undo": "Rückgängig",
    "outfitStack_redo": "Wiederherstellen",
    "outfitStack_empty_prompt": "Wählen Sie Artikel aus der Garderobe, um zu beginnen.",
    "outfitStack_changeColor_aria": "Farbe ändern für {{itemName}}",
    "outfitStack_adjust_aria": "Passform für {{itemName}} anpassen",
    "outfitStack_remove_aria": "{{itemName}} entfernen",
    "outfitStack_findSimilar_aria": "Ähnliche Artikel zu {{itemName}} finden",
    "outfitStack_findSimilar_main": "Ähnliche Artikel kaufen",
    "outfitStack_addToLookbook": "Zum Lookbook hinzufügen",
    "outfitStack_suggestVariations": "Variationen vorschlagen",
    "outfitStack_analyzeColor": "Palette analysieren",
    "outfitStack_creativeTools": "Kreativ-Tools",
    "outfitStack_saveOutfitFirstForLookbook": "Outfit zuerst speichern, um es zum Lookbook hinzuzufügen",
    "alert_selectGarmentFirst": "Bitte wählen Sie zuerst ein Hauptkleidungsstück aus.",

    // Client Stories
    "testimonialsPage_title": "Kundengeschichten",
    "testimonialsPage_tagline": "Hören Sie von unserer globalen Community von Stil-Enthusiasten.",
    "testimonialsPage_workInAction_title": "Ergebnisse in Aktion",
    "testimonialsPage_workInAction_tagline": "Echte Resultate aus unseren Styling-Sessions und Tools.",
    "testimonialsPage_workInAction_connectButton": "Social Media verbinden",
    "testimonialsPage_workInAction_connecting": "Verbinde...",
    "testimonialsPage_workInAction_youtubeTitle": "YouTube Makeovers",
    "testimonialsPage_workInAction_instagramTitle": "Instagram Reels",
    "testimonialsPage_workInAction_twitterTitle": "Style Tweets",
    "threeSixty_dragToRotate": "Ziehen zum Drehen",

    // Testimonials
    "testimonial_name_1": "Sophie M.",
    "testimonial_location_paris": "Paris, Frankreich",
    "testimonial_quote_1": "Constantina hat meine Garderobe verwandelt. Endlich weiß ich, welche Farben mich strahlen lassen!",
    "testimonial_name_2": "Alessandro R.",
    "testimonial_location_milan": "Mailand, Italien",
    "testimonial_quote_2": "Die persönliche Styling-Session war ein Wendepunkt für mein professionelles Image.",
    "testimonial_name_3": "Emma W.",
    "testimonial_location_london": "London, UK",
    "testimonial_quote_3": "Das Aussortieren meines Kleiderschranks mit den KI-Tools hat das Entrümpeln tatsächlich spaßig gemacht.",
    "testimonial_name_4": "Wei L.",
    "testimonial_location_shanghai": "Shanghai, China",
    "testimonial_quote_4": "Habe den Event-Styling-Service für eine Gala genutzt. Die Empfehlungen waren genau richtig.",
    "testimonial_name_5": "Kenji T.",
    "testimonial_location_tokyo": "Tokio, Japan",
    "testimonial_quote_5": "Das Style-Persona-Feature hat meine Ästhetik besser erfasst, als ich es beschreiben konnte.",
    "testimonial_name_6": "Claire D.",
    "testimonial_location_montreal": "Montreal, Kanada",
    "testimonial_quote_6": "Die virtuelle Anprobe hat mir so viel Zeit beim Online-Shopping gespart. Sehr zu empfehlen!",
    "testimonial_name_7": "Elena G.",
    "testimonial_location_barcelona": "Barcelona, Spanien",
    "testimonial_quote_7": "Ich liebe die wöchentlichen Style-Pläne. Es nimmt den Stress aus der Kleiderwahl für die Arbeit.",
    "testimonial_name_8": "Omar K.",
    "testimonial_location_dubai": "Dubai, VAE",
    "testimonial_quote_8": "Ähnliche Artikel anhand von Fotos zu finden ist Magie. Habe eine Jacke gefunden, die ich seit Monaten suche.",

    // Social Content
    "reel_1_caption": "Sommervibes mit unserer neuen Leinenkollektion! ☀️ #summerstyle",
    "reel_2_caption": "Bereit für die Gala-Saison. ✨ #eveningwear #glamour",
    "reel_3_caption": "Streetstyle-Inspiration aus Tokio. 🇯🇵 #streetwear",

    // Capsule Generator
    "capsuleGenerator_title": "KI Capsule Wardrobe Generator",
    "capsuleGenerator_subtitle": "Erstellen Sie eine vielseitige, harmonische Garderobe, die auf Ihren Stil und den Anlass zugeschnitten ist.",
    "capsuleGenerator_premium_required": "Dieses fortschrittliche KI-Styling-Tool steht unseren Premium- und Advanced-Mitgliedern zur Verfügung.",
    "capsuleGenerator_select_season": "Saison auswählen",
    "capsuleGenerator_select_occasion": "Anlass auswählen",
    "capsuleGenerator_generate_btn": "Capsule generieren",
    "capsuleGenerator_generating": "Entwerfe deine Capsule...",
    "capsuleGenerator_season_spring": "Frühling",
    "capsuleGenerator_season_summer": "Sommer",
    "capsuleGenerator_season_autumn": "Herbst",
    "capsuleGenerator_season_winter": "Winter",
    "capsuleGenerator_occasion_work": "Berufsbekleidung",
    "capsuleGenerator_occasion_casual": "Wochenend-Casual",
    "capsuleGenerator_occasion_travel": "Reisen & Urlaub",
    "capsuleGenerator_occasion_formal": "Formelle Anlässe",
    "capsuleGenerator_result_palette": "Farbpalette",
    "capsuleGenerator_result_items": "Schlüsselstücke",
    "capsuleGenerator_result_combinations": "Outfit-Kombinationen",
    "capsuleGenerator_seo_title": "KI Capsule Wardrobe Generator | Constantina Lifestyle",
    "capsuleGenerator_seo_desc": "Generieren Sie eine personalisierte Capsule Wardrobe basierend auf Ihrer Farbsaison, Ihrem Körpertyp und Ihrer Stil-Persona mit fortschrittlicher KI.",
    "capsuleGenerator_seo_keywords": "Capsule Wardrobe, KI-Stylist, Modeplanung, minimalistische Garderobe, Farbsaison-Analyse",

    // Retail Search
    "retailSearchModal_title": "Ähnliche Artikel finden",
    "retailSearchModal_titleForGarment": "Ähnlich wie: {{garmentName}}",
    "retailSearchModal_close": "Schließen",
    "retailSearchModal_refine_title": "Suche verfeinern",
    "retailSearchModal_refine_color": "Farbe",
    "retailSearchModal_refine_pattern": "Muster",
    "retailSearchModal_refine_material": "Material",
    "retailSearchModal_refine_color_placeholder": "z.B. Navyblau",
    "retailSearchModal_refine_pattern_placeholder": "z.B. Gestreift",
    "retailSearchModal_refine_material_placeholder": "z.B. Seide",
    "retailSearchModal_refine_button": "Suche aktualisieren",
    "retailSearchModal_loading": "Suche bei globalen Händlern...",
    "retailSearchModal_noResults": "Keine ähnlichen Artikel gefunden.",
    "retailSearchModal_sources": "Quellen",
    "retailSearchModal_noPreview": "Keine Vorschau",
    "youtube_1_title": "10 Garderoben-Essentials",
    "youtube_1_published": "vor 2 Tagen",
    "youtube_2_title": "Wie man Oversized-Blazer stylt",
    "youtube_2_published": "vor 1 Woche",
    "tweet_1_author": "Fashion Weekly",
    "tweet_1_text": "Die Rückkehr der 90er-Ästhetik ist gekommen, um zu bleiben. Was ist dein liebstes Retro-Teil? 🧥",
    "tweet_1_timestamp": "vor 2 Std.",
    "tweet_2_author": "Style Scout",
    "tweet_2_text": "Gerade die neue Constantina-Kollektion entdeckt. Absolutes Feuer! 🔥 Das KI-Styling-Tool ist ein Game Changer.",
    "tweet_2_timestamp": "vor 5 Std.",

    // Lookbook & Social
    "lookbookCreatorModal_aspectRatio": "Seitenverhältnis",
    "lookbookCreatorModal_socialLayout": "Social Media Layout (Influencer-Stil)",
    "lookbookCreatorModal_socialLayoutDesc": "Optimiert für Instagram Stories und TikTok.",
    "lookbookCreatorModal_socialCaption": "KI Social Media Text",
    "lookbookCreatorModal_captionPlaceholder": "KI-generierter Text erscheint hier...",
    "lookbookCreatorModal_download": "Bild herunterladen",
    "lookbookCreatorModal_error_enterName": "Bitte geben Sie einen Namen für Ihr Lookbook ein.",

    // Profile Page
    "profilePage_measurements_title": "Maße & Attribute",
    "profilePage_measurements_description": "Halten Sie Ihre Angaben aktuell für bessere Passform-Empfehlungen.",
    "profilePage_personalDetails_title": "Persönliche Angaben",
    "profilePage_measurements_height": "Größe",
    "profilePage_measurements_weight": "Gewicht",
    "profilePage_measurements_chest": "Brustumfang",
    "profilePage_measurements_waist": "Taillenumfang",
    "profilePage_measurements_hips": "Hüftumfang",
    "profilePage_measurements_height_placeholder": "cm/ft",
    "profilePage_measurements_weight_placeholder": "kg/lbs",
    "profilePage_measurements_chest_placeholder": "cm/in",
    "profilePage_measurements_waist_placeholder": "cm/in",
    "profilePage_measurements_hips_placeholder": "cm/in",
    "profilePage_measurements_shoeSize": "Schuhgröße",
    "profilePage_measurements_shoeSize_placeholder": "z.B. 42 / 9",
    "profilePage_attributes_detected_title": "Erkannte Attribute",
    "profilePage_attributes_bodySize": "Körpergröße",
    "profilePage_attributes_hairColor": "Haarfarbe",
    "profilePage_attributes_eyeColor": "Augenfarbe",
    "profilePage_attributes_faceShape": "Gesichtsform",
    "profilePage_attributes_notDetected": "Nicht erkannt",
    "profilePage_preferredRetailers_label": "Bevorzugte Händler",
    "profilePage_preferredRetailers_description": "Wählen Sie Marken, die Sie lieben, für bessere Empfehlungen.",
    "profilePage_membership_title": "Mitgliedschaft",
    "profilePage_membership_tagline": "Verwalten Sie Ihr Abonnement.",
    "profilePage_membership_level": "Aktueller Plan",
    "profilePage_membership_expiry_date": "Ablaufdatum",
    "profilePage_membership_status_basic": "Basis",
    "profilePage_membership_status_active": "{{level}} - Aktiv bis {{date}}",
    "profilePage_membership_status_active_no_date": "{{level}} - Aktiv",
    "profilePage_membership_status_expired": "{{level}} - Abgelaufen am {{date}}",
    "profilePage_membership_basic": "Basis",
    "profilePage_membership_premium": "Premium",
    "profilePage_membership_advanced": "Advanced",
    "profilePage_membership_nextgen": "NextGen Zugang",
    "profilePage_membership_current": "Aktueller Plan",
    "profilePage_membership_change_hint": "Nur via Upgrade-Zahlung änderbar",
    "profilePage_membership_upgrade": "Upgrade",
    "profilePage_membership_label": "Mitgliedschaft",
    "profilePage_membership_month": "Mt.",
    "profilePage_membership_current_label": "Aktueller Plan",
    "profilePage_membership_upgrade_button": "Upgrade",
    "profilePage_mobileApp_title": "Nehmen Sie Ihren Stil überallhin mit",
    "profilePage_mobileApp_description": "Als Premium-Mitglied haben Sie exklusiven Zugriff auf unsere mobile Begleiter-App. Verwalten Sie Ihre Garderobe, erhalten Sie tägliche Briefings und nutzen Sie die Style-Sandbox unterwegs.",
    "profilePage_mobileApp_qrTitle": "Zum Herunterladen scannen",
    "auth_coupon_placeholder": "Gutscheincode (Optional)",
    "user_status_registered": "Registriert",
    "user_status_validated": "Wartet auf Genehmigung",
    "user_status_active": "Aktiv",
    "user_status_inactive": "Inaktiv",
    "user_status_deleted": "Gelöscht",
    "auth_pending_admin": "Konto wartet auf Admin-Freigabe",
    "auth_pending_confirmation": "Bitte bestätigen Sie Ihre E-Mail-Adresse.",
    "auth_account_deactivated": "Dieses Konto wurde deaktiviert.",
    "stylingAdvisorPage_questionnaire_wizard_title": "Stil-Entdeckungs-Assistent",
    "stylingAdvisorPage_questionnaire_wizard_success": "Ihr Stil-Persona wurde entdeckt!",
    "stylingAdvisorPage_questionnaire_wizard_step_evolution": "Welche Phase der inneren Entwicklung spiegeln Sie derzeit wider?",
    "stylingAdvisorPage_questionnaire_wizard_phase_emergence": "Entstehung",
    "stylingAdvisorPage_questionnaire_wizard_phase_leadership": "Führung",
    "stylingAdvisorPage_questionnaire_wizard_phase_reclamation": "Rückgewinnung",
    "stylingAdvisorPage_questionnaire_wizard_phase_transition": "Übergang",
    "stylingAdvisorPage_questionnaire_wizard_phase_mastery": "Meisterschaft",
    "stylingAdvisorPage_questionnaire_wizard_step_archetype": "Was ist Ihr aktueller Stil-Archetyp?",
    "stylingAdvisorPage_questionnaire_wizard_arch_muse": "Muse",
    "stylingAdvisorPage_questionnaire_wizard_arch_warrior": "Krieger",
    "stylingAdvisorPage_questionnaire_wizard_arch_creator": "Schöpfer",
    "stylingAdvisorPage_questionnaire_wizard_arch_healer": "Heiler",
    "stylingAdvisorPage_questionnaire_wizard_arch_ruler": "Herrscher",
    "stylingAdvisorPage_questionnaire_wizard_arch_magician": "Magier",
    "stylingAdvisorPage_questionnaire_wizard_step_generation": "Welcher Generation gehören Sie an?",
    "stylingAdvisorPage_questionnaire_wizard_gen_alpha": "Gen Alpha",
    "stylingAdvisorPage_questionnaire_wizard_gen_z": "Gen Z",
    "stylingAdvisorPage_questionnaire_wizard_gen_millennial": "Millennial",
    "stylingAdvisorPage_questionnaire_wizard_gen_x": "Gen X",
    "stylingAdvisorPage_questionnaire_wizard_gen_boomer": "Boomer",
    "stylingAdvisorPage_questionnaire_wizard_gen_classic": "Klassisch",
    "stylingAdvisorPage_questionnaire_wizard_step_lifestyle": "Erzählen Sie uns von Ihrem Lebensstil",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_office": "Wie viel Zeit verbringen Sie im Büro?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_travel": "Wie viel reisen Sie?",
    "stylingAdvisorPage_questionnaire_wizard_intensity_none": "Keine",
    "stylingAdvisorPage_questionnaire_wizard_intensity_low": "Niedrig",
    "stylingAdvisorPage_questionnaire_wizard_intensity_medium": "Mittel",
    "stylingAdvisorPage_questionnaire_wizard_intensity_high": "Hoch",
    "stylingAdvisorPage_questionnaire_wizard_step_persona": "Wählen Sie Ihre Stil-Persona",
    "stylingAdvisorPage_questionnaire_wizard_finish": "Meinen Stil entdecken",
    "homePage_solveStyleProblem_link": "Ein Stilproblem lösen",
    "homePage_bookSession_link": "Sitzung buchen",
    "homePage_forCompanies_link": "Für Unternehmen",
    "stylingAdvisorPage_questionnaire_wizard_persona_minimalist": "Minimalistisch",
    "stylingAdvisorPage_questionnaire_wizard_persona_bohoChic": "Boho Chic",
    "stylingAdvisorPage_questionnaire_wizard_persona_classicProfessional": "Klassisch Professionell",
    "stylingAdvisorPage_questionnaire_wizard_persona_streetwear": "Streetwear",
    "stylingAdvisorPage_questionnaire_wizard_persona_avantGarde": "Avantgarde",
    "stylingAdvisorPage_questionnaire_wizard_persona_vintageRetro": "Vintage Retro",
    "stylingAdvisorPage_questionnaire_wizard_persona_activewear": "Sportbekleidung",
    "stylingAdvisorPage_questionnaire_wizard_persona_glamorous": "Glamourös"
  }
};
